import { vueAppWithStore } from "../Common/vueApp";
import LiveStreamsManageApp from "./LiveStreamsManageApp.vue";
import Vuex from "vuex";
import { promiseRequestFactory, requestMutations, requestState } from "../Common/Vuex/request";
import { default as liveStreamsApi } from "../Api/liveStreams";

const store = new Vuex.Store({
    modules: {
        main: {
            namespaced: true,
            state: {
                ...requestState,
                eventId: 0,
                liveStreams: [],
                mats: [],
            },
            mutations: {
                ...requestMutations,
                setEventId(state, eventId) {
                    state.eventId = eventId;
                },
                setLiveStreams(state, liveStreams) {
                    state.liveStreams = liveStreams;
                },
                setMats(state, mats) {
                    state.mats = mats;
                },
            },
            getters: {
                eligibleMatsForAddingStream(state) {
                    return state.mats.filter(mat => {
                        return !state.liveStreams.some(liveStream => {
                            return liveStream.matId === mat.id;
                        });
                    });
                },
            },
            actions: {
                refreshLiveStreams(context) {
                    return liveStreamsApi
                        .init(promiseRequestFactory(context))
                        .getListing(context.state.eventId)
                        .then(liveStreams => {
                            context.commit("setLiveStreams", liveStreams);
                        });
                },
            },
        },
    },
});

export default vueAppWithStore(LiveStreamsManageApp, store);
